export const getXLIF = (xliff) => {
  // Return action
  return {
    // Unique identifier
    type: 'GET_XLIF',
	xliff: xliff
  }
};
export const updateXLIF = (xliff) => {
  // Return action
  return {
    // Unique identifier
    type: 'UPDATE_XLIF',
	xliff: xliff
  }
};

export const getSegments = (TUs) => {
  // Return action
  return {
    // Unique identifier
    type: 'GET_SEGMENTS',
	TUs: TUs
  }
};

export const nextSegment = () => {
  // Return action
  return {
    // Unique identifier
    type: 'NEXT_SEG'
  }
};

export const previousSegment = () => {
  // Return action
  return {
    // Unique identifier
    type: 'PREVIOUS_SEG'
  }
};

export const gotoSegment = (iTu, iSeg) => {
  // Return action
  return {
    // Unique identifier
    type: 'GOTO_SEG',
	iTu: iTu,
	iSeg: iSeg
  }
};

export const updateCurrentSegment = (segmentMod) => {
  // Return action
  return {
    // Unique identifier
    type: 'UPDATE_CURR_SEG',
	segmentMod: segmentMod
  }
};

export const updateCurrentSpellError = (segmentMod, spellErrors) => {
  // Return action
  return {
    // Unique identifier
    type: 'UPDATE_CURR_SPELL_ERROR',
	segmentMod: segmentMod,
	spellErrors: spellErrors
  }
};

export const updateSegment = (segmentMod, iTu, iSeg) => {
  // Return action
  return {
    // Unique identifier
    type: 'UPDATE_SEG',
	segmentMod: segmentMod,
	iTu: iTu,
	iSeg: iSeg
  }
};

export const setTmx = (tmx) => {
  return {
    type: 'SET_TMX',
	tmx: tmx
  }
};
